import { Box, ButtonBase } from '@mui/material';
import React from 'react';

import { DialpadProps } from './Dialpad.props';

const KEYS: ReadonlyArray<{ digit: string; letters: string }> = [
  { digit: '1', letters: '' },
  { digit: '2', letters: 'ABC' },
  { digit: '3', letters: 'DEF' },
  { digit: '4', letters: 'GHI' },
  { digit: '5', letters: 'JKL' },
  { digit: '6', letters: 'MNO' },
  { digit: '7', letters: 'PQRS' },
  { digit: '8', letters: 'TUV' },
  { digit: '9', letters: 'WXYZ' },
  { digit: '*', letters: '' },
  { digit: '0', letters: '+' },
  { digit: '#', letters: '' },
];

export const Dialpad: React.FC<DialpadProps> = ({ onDigit, disabled = false }) => (
  <Box
    role="group"
    aria-label="Dialpad"
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 1,
    }}
  >
    {KEYS.map(({ digit, letters }) => (
      <ButtonBase
        key={digit}
        onClick={() => onDigit(digit)}
        disabled={disabled}
        aria-label={`Dial ${digit}`}
        sx={{
          aspectRatio: '1.6 / 1',
          borderRadius: 1.5,
          border: '1px solid',
          borderColor: 'v4.border',
          bgcolor: 'v4.surface',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          color: 'text.primary',
          fontWeight: 500,
          transition: 'background-color 0.12s, transform 0.06s',
          '&:hover:not(.Mui-disabled)': { bgcolor: 'v4.tableHover' },
          '&:active:not(.Mui-disabled)': { transform: 'scale(0.97)' },
          '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main' },
          '&.Mui-disabled': { opacity: 0.5 },
        }}
      >
        <Box sx={{ fontSize: 18, lineHeight: 1 }}>{digit}</Box>
        {letters && (
          <Box sx={{ fontSize: 9, color: 'text.secondary', letterSpacing: 1 }}>{letters}</Box>
        )}
      </ButtonBase>
    ))}
  </Box>
);
